/**
 * المقاس القياسي الوحيد لبلوكات الصفحة الرئيسيّة (وسائط بعرض كامل).
 * ممنوع اختراع ارتفاع/نسبة أبعاد جديدة في أيّ بلوك — استورد هذا الثابت.
 */
export const HOME_BLOCK_HEIGHT = "min-h-[78svh] sm:min-h-[60svh]";
